import React from 'react'
import { ReactComponent as CompilerSvg } from '../images/compiler.svg'
import { ReactComponent as SettingSvg } from '../images/setting.svg'
import { ReactComponent as LiferaySvg } from '../images/liferay.svg'
import { ReactComponent as MobileAppSvg } from '../images/mobile.svg'
import broucher from "../Samplefiles/GIKS_Brochure.pdf";

const ItSecurityManagement = () => {
  return (
    <>
        <section className="about-who-we-are repeated-hero-banner services-itSecurityManagement-development">
        <div className="container">
            <div className="row">
                <div className="col-md-10 col-lg-10">
                    <div className="about-single-content">
                        <h1 className="common-heading">IT Security Management</h1>
                        <p className="common-para">
                        With a team of highly skilled professionals, we offer comprehensive solutions to safeguard your digital assets and protect against evolving cybersecurity threats. From risk assessments and vulnerability management to incident response and security monitoring, we ensure the resilience and integrity of your IT infrastructure. 
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section className="services-about">
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <h2 className="sub-pages-heading">Firewall Management</h2>
                    <p className="common-para">
                       If you aspire to embrace innovation through cloud, analytics, mobility, and social business, our Firewall management service offers a flat-pricing model and a vendor-neutral approach. This approach not only reduces costs and mitigates risks but also enables effective regulatory compliance management and meets the requirements of a highly interconnected and data-driven world.
                    </p>
                </div>
            </div>
            <div className="row mt-60">
                <div className="col-lg-4">
                    <p className="product-services-box-heading">
                      Intrusion Detection and Prevention System Management
                    </p>
                    <p className="common-para">
                    The management of intrusion detection and prevention systems aims to deliver strong, instantaneous security monitoring, administration, and analysis for networks and servers.gn.
                    </p>
                </div>
                <div className="col-lg-4">
                    <p className="product-services-box-heading">
                    Security-Rich Web Gateway Management
                    </p>
                    <p className="common-para">
                    Our Security Services offers the most comprehensive range of consulting and global managed security services in the industry. We provide top-notch assessments and security strategies to major enterprises worldwide, including critical approaches like zero trust.
                    </p>
                </div>
                <div className="col-lg-4">
                    <p className="product-services-box-heading">
                       Unified Threat Management
                    </p>
                    <p className="common-para">
                     GIKS India provides cutting-edge AI insights to streamline and coordinate essential tasks. Our diverse programs seamlessly combine the strengths of penetration testing, managed security services, incident response, artificial intelligence, and a digital protection platform.
                    </p>
                </div>
                <div className="col-lg-4">
                    <p className="product-services-box-heading">
                    Secure SD-WAN
                    </p>
                    <p className="common-para">
                    The task of securing modern enterprises is increasingly challenging due to the rising number of endpoints and wide area networks (WAN) that require protection. Users now expect access to applications and data beyond the conventional security boundaries, while the cybercrime landscape continues to grow more hostile.
                    </p>
                </div>
                <div className="col-lg-4">
                    <p className="product-services-box-heading">
                    Endpoint Security Services
                    </p>
                    <p className="common-para">
                    With our extensive experience of over 5+ years in endpoint security, we provide cutting-edge tools, technology, and round-the-clock support to ensure the security of your environment. Our dedicated service delivery team efficiently manages multiple platforms, safeguarding millions of endpoints for hundreds of clients.                                                                                                                                                                        
                    </p>
                </div>
                <div className="col-lg-4">
                    <p className="product-services-box-heading">
                      Amazon Guard Duty Services
                    </p>
                    <p className="common-para">
                    Experience enhanced, unified data protection for your hybrid AWS cloud environment through our services. Benefit from a comprehensive range of powerful security controls, including discovery and classification, vulnerability and risk assessments, real-time monitoring and alerting, encryption, and advanced analytics.
                    </p>
                </div>
            </div>
            <div className="row mt-60">
                <div className="col-md-12">
                    <h2 className="sub-pages-heading">What is IT Security Management</h2>
                    <p className="common-para">
                    IT security management refers to the practice of protecting information technology systems and data from unauthorized access, disruptions, and threats. It involves implementing and maintaining a set of policies, procedures, and technologies to ensure the confidentiality, integrity, and availability of IT resources.
                    </p>
                </div>
            </div>
            <div className="row mt-60">
                <div className="col-md-12">
                    <ul className="list-unstyled ps-0 first">
                        <li>
                            <p className="product-services-box-heading">
                              Provides Security to all Your Information
                            </p>
                            <p className="common-para">
                            An Information Security Management System (ISMS) ensures the protection of all your information, including intellectual property, company secrets, personal data, and other forms of information. It doesn't matter if the information is in digital or physical format, or where it is stored. The ISMS provides security across all forms and storage locations without any distinction
                            </p>
                        </li>
                        <li>
                            <p className="product-services-box-heading">
                              Enhances Defence Against Cyber-Attacks
                            </p>
                            <p className="common-para">
                            By implementing an Information Security Management System (ISMS), your organization's ability to withstand cyber-attacks is enhanced.
                            </p>
                        </li>
                        <li>
                            <p className="product-services-box-heading">
                               Reduces security-related costs
                            </p>
                            <p className="common-para">
                                With a cloud built on Docker, RAD helps apps to scale out. Microservices architecture is
                                replacing the super app with a network of smaller apps.
                            </p>
                        </li>
                        <li>
                            <p className="product-services-box-heading">
                               Improves company work culture: 
                            </p>
                            <p className="common-para">
                            The comprehensive nature of an ISMS encompasses the entire organization, encompassing not only the IT department but also the people, processes, and technologies involved.
                            </p>
                        </li>
                        <li>
                            <p className="product-services-box-heading">
                              Safeguard confidentiality, integrity and availability of data
                            </p>
                            <p className="common-para">
                              A robust ISMS provides a range of policies, technical measures, and physical controls to safeguard the confidentiality, integrity, and availability of an organization's data.
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="row mt-60">
                <div className="col-md-12">
                    <h2 className="sub-pages-heading">User Security Management</h2>
                    <p className="common-para">
                    Privileges dictate the actions that users are permitted to perform on domain objects, while permissions determine the level of access a user possesses for a particular domain object. Domain objects encompass various entities such as the domain itself, folders, nodes, grids, licenses, database connections, operating system profiles, and application services.
                    </p>
                </div>
            </div>
            <div className="row mt-60">
                <div className="col-md-12">
                    <h2 className="sub-pages-heading">Security Assessment services</h2>
                    <ul className="second">
                        <li className="common-para">Risk Assessment and Risk Treatment</li>
                        <li className="common-para">Security Process Audits</li>
                        <li className="common-para">Pentest</li>
                        <li className="common-para">Security Testing of Source Code</li>
                        <li className="common-para">Vulnerability Assessment</li>
                      

                    </ul>
                </div>
            </div>
            <div className="row mt-60">
                <div className="col-md-12">
                    <h2 className="sub-pages-heading">IT Infrastructure Protection Service</h2>
                    <ul className="second">
                    <li className="common-para">Web Application Firewall (WAF) solution</li>
                    <li className="common-para">Intrusion Prevention System (IPS) implementation</li>
                    <li className="common-para">Network Implementation Services</li>
                    <li className="common-para">Network Operation Services</li>
                    </ul>
                </div>
            </div>
            <div className="row mt-60">
                <div className="col-lg-3">
                    <div className="what-we-do">

                        <CompilerSvg/>


                        <p className="product-services-box-heading mb-1 mt-2">
                            Website Development
                        </p>
                        <p className="common-para">
                        As a web and app development company, we specialize in transforming your ideas into powerful catalysts for your business growth.</p>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="what-we-do">

                    <SettingSvg/>

                    <p className="product-services-box-heading mb-1 mt-2">
                        Custom App Development
                    </p>
                    <p className="common-para">
                    With our proficiency in e-commerce, adtech/martech, peer-to-peer sectors, and various other business domains, we excel in crafting bespoke web and mobile solutions that cater to the unique needs of our clients.</p></div>
                </div>
                <div className="col-lg-3">
                    <div className="what-we-do">

                    <LiferaySvg/>

                    <p className="product-services-box-heading mb-1 mt-2">
                        Liferay Development
                    </p>
                    <p className="common-para">
                    Liferay DXP empowers developers with a comprehensive platform for fast creation of web apps, mobile apps, and web services. Its feature-rich frameworks prioritize rapid development, optimal performance, and user-friendly experience.</p></div>
                </div>
                <div className="col-lg-3">
                    <div className="what-we-do">
                    
                    <MobileAppSvg/>
    
                    <p className="product-services-box-heading mb-1 mt-2">
                        Mobile App Development
                    </p>
                    <p className="common-para">
                    For the efficient development of fast and seamless applications across multiple platforms, we offer an outsourcing app development model. This model provides a cost-effective solution for managing budgets and resources while ensuring the creation of high-quality products..</p></div>
                </div>
            </div>
            <div className='row'>
                <div className='col-lg-12'>
                <button className="download-brochure border-0 download-brochure">
                                    <span className="icon">
                                        <svg width="20" height="26" viewBox="0 0 20 26" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M6.25 10.5H7.5C7.83152 10.5 8.14946 10.3683 8.38388 10.1339C8.6183 9.89946 8.75 9.58152 8.75 9.25C8.75 8.91848 8.6183 8.60054 8.38388 8.36612C8.14946 8.1317 7.83152 8 7.5 8H6.25C5.91848 8 5.60054 8.1317 5.36612 8.36612C5.1317 8.60054 5 8.91848 5 9.25C5 9.58152 5.1317 9.89946 5.36612 10.1339C5.60054 10.3683 5.91848 10.5 6.25 10.5ZM6.25 13C5.91848 13 5.60054 13.1317 5.36612 13.3661C5.1317 13.6005 5 13.9185 5 14.25C5 14.5815 5.1317 14.8995 5.36612 15.1339C5.60054 15.3683 5.91848 15.5 6.25 15.5H13.75C14.0815 15.5 14.3995 15.3683 14.6339 15.1339C14.8683 14.8995 15 14.5815 15 14.25C15 13.9185 14.8683 13.6005 14.6339 13.3661C14.3995 13.1317 14.0815 13 13.75 13H6.25ZM20 9.175C19.987 9.06017 19.9618 8.94704 19.925 8.8375V8.725C19.8649 8.59647 19.7847 8.47833 19.6875 8.375L12.1875 0.875C12.0842 0.77777 11.966 0.697601 11.8375 0.6375C11.8002 0.6322 11.7623 0.6322 11.725 0.6375C11.598 0.564677 11.4578 0.51793 11.3125 0.5H3.75C2.75544 0.5 1.80161 0.895088 1.09835 1.59835C0.395088 2.30161 0 3.25544 0 4.25V21.75C0 22.7446 0.395088 23.6984 1.09835 24.4017C1.80161 25.1049 2.75544 25.5 3.75 25.5H16.25C17.2446 25.5 18.1984 25.1049 18.9017 24.4017C19.6049 23.6984 20 22.7446 20 21.75V9.25C20 9.25 20 9.25 20 9.175ZM12.5 4.7625L15.7375 8H13.75C13.4185 8 13.1005 7.8683 12.8661 7.63388C12.6317 7.39946 12.5 7.08152 12.5 6.75V4.7625ZM17.5 21.75C17.5 22.0815 17.3683 22.3995 17.1339 22.6339C16.8995 22.8683 16.5815 23 16.25 23H3.75C3.41848 23 3.10054 22.8683 2.86612 22.6339C2.6317 22.3995 2.5 22.0815 2.5 21.75V4.25C2.5 3.91848 2.6317 3.60054 2.86612 3.36612C3.10054 3.1317 3.41848 3 3.75 3H10V6.75C10 7.74456 10.3951 8.69839 11.0983 9.40165C11.8016 10.1049 12.7554 10.5 13.75 10.5H17.5V21.75ZM13.75 18H6.25C5.91848 18 5.60054 18.1317 5.36612 18.3661C5.1317 18.6005 5 18.9185 5 19.25C5 19.5815 5.1317 19.8995 5.36612 20.1339C5.60054 20.3683 5.91848 20.5 6.25 20.5H13.75C14.0815 20.5 14.3995 20.3683 14.6339 20.1339C14.8683 19.8995 15 19.5815 15 19.25C15 18.9185 14.8683 18.6005 14.6339 18.3661C14.3995 18.1317 14.0815 18 13.75 18Z"
                                                fill="white" />
                                        </svg>
                                    </span>
                                    <a target="_blank" href={broucher}>                 
                   <span className="icon-heading common-para">Download Brochure</span>                 
                </a>
                                    {/* <span className="icon-heading common-para">Download Brochure</span> */}
                                </button>
                </div>
            </div>
            
        </div>
    </section>
    </>
  )
}

export default ItSecurityManagement